import { render, staticRenderFns } from "./OrderPlanList.vue?vue&type=template&id=38d04738&scoped=true&"
import script from "./OrderPlanList.vue?vue&type=script&lang=js&"
export * from "./OrderPlanList.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlanList.vue?vue&type=style&index=0&id=38d04738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d04738",
  null
  
)

export default component.exports